import { createSelector } from '@reduxjs/toolkit';
import { entitiesSelector } from "./base";
export const formSelector = createSelector(entitiesSelector, ({
  app
}) => app);
export const formNameSelector = createSelector(formSelector, ({
  name
}) => name);
export const useReferenceDataInDispatchSelector = createSelector(formSelector, ({
  use_reference_data_in_dispatch_manager
}) => use_reference_data_in_dispatch_manager);